import { images } from "@img/imagesMap";

function Roster_dashboard() {
  return (
    <div style={{ overflow: "auto" }}>
      <img src={images.dashboard} alt="" />
    </div>
  );
}

export default Roster_dashboard;
